<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img alt="" src="images/height-gsc.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>国寿财高危行业4-6类团意险</h2>
					<div>行业超低价 | 国寿财险 | 全线上操作</div>
					<p>
						① 多档调节，随心选择；
						<br />
						② 投保简便支持月单；
						<br />
						③ 社保用药100%赔付；
						<br />
						④ 5人起保，保额高达100万；
					</p>
					<div>
						<el-button size="medium" type="warning" @click.native="handleInsure(0)">立即投保</el-button>
						<el-button size="medium" type="primary" @click.native="handleInsure(1)">投保计划书</el-button>
					</div>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 5px"
						type="text"
						@click.native="handleDownLoad">
						下载国寿财职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<el-row>
						<el-col :span="12">
							价格方案：
							<el-radio-group v-model="dangci" @change="computePrice">
								<el-radio :label="0" border>1档</el-radio>
								<!--
                <el-radio :label="1" border>2档（1.10）</el-radio>
                -->
								<el-radio :label="2" border>3档</el-radio>
							</el-radio-group>
						</el-col>
						<el-col :span="12">
							保障期限：
							<el-select v-model="qixian" placeholder="请选择保障期限" @change="computePrice">
								<el-option
									v-for="item in qixians"
									:key="item.value"
									:label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</el-col>
					</el-row>
					<avue-crud ref="crud" :data="dataPlan" :option="optionPlan" :span-method="spanMethodPlan"></avue-crud>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="24">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ qa.question }}</span>
								</div>
								<p></p>
								<div>
									<span
										style="
											display: inline-block;
											width: 20px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>
									<span v-html="qa.answer"></span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="24">
						<h2 style="color: red">【一、产品责任/保障方案介绍】</h2>
						<div style="line-height: 28px; margin-left: 20px">
							<span class="font_title">本产品相关保险条件：</span>
							<br />
							<span class="font_title">1、每一被保险人在同一保险期间内限投保壹份，多投保无效。</span>
							<br />
							<span class="font_title">2、保险期间</span>
							<br />
							<div style="margin-left: 20px">
								本产品保险期间为1年（含短期单：6个月、3个月、1个月，费率以条款短期费率为准），以保险合同载明的起讫时间为准。
								<br />
								<span style="font-weight: bold">
									本产品保单自您完成投保操作并成功支付保险费之日T+2日零时生效。保单生效后，保险人开始承担保险责任，保单生效前发生的保险事故，保险人不承担保险责任。
								</span>
							</div>
							<span class="font_title">3、医院机构就诊范围</span>
							<br />
							<span style="margin-left: 20px">
								本产品适用的就诊医疗机构范围为：中华人民共和国境内（不含港、澳、台地区）二级及以上医院或者保险人指定或认可的医疗机构。但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。对于前往非本保单指定就诊医院所产生的医疗费用，保险人有权拒绝赔偿。
							</span>
							<br />
							<span class="font_title">4、医疗费用免赔额及给付比例</span>
							<br />
							<span style="margin-left: 20px">
								对被保险人所支出的必要、合理的且属于当地社会医疗保险报销范围的意外伤害医疗费用，保险人每次扣除绝对免赔额RMB0元后，在意外伤害医疗费用保险金额范围内按照100%比例给付。
							</span>
							<br />
							<span style="margin-left: 20px">
								保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任的期限，门诊治疗者，自保险期间届满次日起计算，以15日为限；住院治疗者至出院之日止，自保险期间届满次日起计算，最长以90日为限。
							</span>
							<br />
							<span class="font_title">5、等待期</span>
							<br />
							<span style="margin-left: 20px">
								本产品无等待期（指自保险期间开始之日起至保险责任开始之日止的时段）。
							</span>
							<br />
							<span class="font_title">6、特别约定</span>
							<br />
							<div style="margin-left: 20px; font-weight: bold">
								(1)、
								<span class="red-bold">
									出险后，被保险人必须在72小时内通过微信小程序“线上快赔”上传出险照片报案，报案服务咨询可拨打本保单第11条特别约定中的电话号码，取得报案号后才是报案成功(否则报案失败)。
								</span>
								如果被保险人委托第三人/第三方报案，后被保险人必须及时联系第三人/第三方，获取报案号。否则因第三人/第三方延迟报案，导致保险人按本保单第11条特别约定扣除免赔，那么被保险人须自行承担相关损失。
								<br />
								(2)、本保单承保的职业类别按风险从低到高，可分为4-6类，6类风险最高。
								<br />
								(3)、
								<span class="red-bold">
									本保单拒绝承保职业（即保险人不承担任何赔偿责任）：农牧渔业、海上作业、地质矿产业、化工/军工制造业、影视及演艺业、建筑物外墙维护及玻璃幕墙安装维护人员、特别约定桥梁/隧道工程人员、凿岩工、防水工、水运工程施工、水坝工程人员、潜水工作人员、体育运动、各种杂技人员、驯兽师、涉及火药/炸药/爆破的相关工作、易燃易爆/危险化学品运输司机及随车工、特种兵/军人/武警/公安/警察/消防等治安人员、高压电工作人员、快递/外卖配送等。
								</span>
								<br />
								(4)、
								<span class="red-bold">
									兹保险双方协商并同意，若从事高处作业，必须投保5-6类职业，否则发生保险事故，保险人不承担赔偿责任。
								</span>
								高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准。
								<span class="red-bold">
									从事高处作业须系安全带，且须持有有效的特种作业操作证（高处作业），否则保险人对按保单规定的应承担的保险责任，免赔50%。
								</span>
								<br />
								(5)、
								<span class="red-bold">
									兹保险双方协商并同意，投保4类职业的人员，若从事高处作业发生保险事故，则保险人不承担赔偿责任；若从事其他5-6类职业工作（不涉及高处作业）发生保险事故，则保险人对按保单约定的应承担的保险责任，免赔50%。
								</span>
								<br />
								(6)、以下情形，保险人不得以保单上列明职业有误而拒赔或者减少承担赔偿责任：保单上列明职业类别对应的保费，不低于被保险人实际职业类别对应的保费。
								<br />
								(7)、兹保险双方协商并同意，本保单不支持批减被保险人、变更保额。保险期限为3个月以内（含）的保单不支持替换被保险人，6个月和1年的保单支持替换被保险人（已出险人员除外）。
								<br />
								(8)、保险人赔付标准如下：
								<br />
								① 对于身故：按限额100%赔付。
								<br />
								②
								对于伤残：经司法鉴定后，伤残按一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、10级10%的比例赔付。
								<br />
								③
								对于医疗费用：保险人按投保人营业执照注册地（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准赔付。
								<span class="red-bold">
									保险期间届满被保险人治疗仍未结束的，保险人继续承担给付保险金责任的期限，门诊治疗者，自保险期间届满次日起计算，以15日为限；住院治疗者至出院之日止，自保险期间届满次日起计算，最长以90日为限。
								</span>
								<br />
								④
								<span class="red-bold">
									对于住院津贴：在保险期间内每次事故赔偿不超过90天，累计不超过180天，无免赔。
								</span>
								身故/伤残保额10-30万的方案，每人每天100元；40-70万的方案，每人每天150元；80-100万的方案，每人每天200元。
								<br />
								(9)、
								<span class="red-bold">
									本保单指定就诊医院为大陆境内二级及以上公立医院，或保险人认可的其他医疗机构（如被保险人所在乡镇的公立医疗机构），但不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市。
								</span>
								对于前往非本保单指定就诊医院所产生的医疗费用，保险人有权拒绝赔偿。
								<br />
								(10)、
								<span class="red-bold">保险人不赔偿如下责任：</span>
								<br />
								①
								<span class="red-bold">拒绝承保职业。</span>
								<br />
								②
								<span class="red-bold">保险条款责任免除部分。</span>
								<br />
								③
								<span class="red-bold">精神损害、猝死、疾病所致治疗和身故。</span>
								<br />
								(11)、
								<span class="red-bold">
									兹保险双方协商并同意，被保险人必须在保险事故发生后24小时内拨打电话400-180-1616进行报案（如属于死亡或重伤事故，须在12小时内报案），因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任；如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%；
								</span>
								如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权追究被保险人及相关人员的刑事责任。
								<br />
								(12)、兹保险双方协商并同意，本保单累计赔偿限额为1000万。若伤亡事故造成的实际损失超1000万，对于超过部分，保险人不承担赔偿责任。
								<br />
								(13)、本保单扩展年龄规范保险条款，本保单承保被保险人年龄区间须为十六周岁（含）至六十五周岁（含）。
							</div>
							<span class="font_title">7、责任免除</span>
							<br />
							<span class="font_head">
								“中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）”责任免除详情
							</span>
							<span class="font_head" style="color: red">
								以下内容请您务必认真阅读！以下内容涵盖了本产品保险合同约定的主要免除责任，即保险公司不承担给付保险金责任或仅赔付部分保险金的情形。详细的责任免除相关内容请见《保险条款》。
							</span>
							<span class="font_head font_center" style="color: red; text-align: center">
								★保险公司不予给付保险金的责任免除★
							</span>
							<span class="font_head" style="color: red">
								《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》
							</span>
							<span class="font_title">
								因下列原因造成被保险人身故、伤残、支出医疗费用、住院治疗、突发急性病身故或猝死的，保险人不承担给付保险金责任：
							</span>
							<br />
							<div style="margin-left: 20px">
								（一）投保人的故意或重大过失行为；
								<br />
								（二）被保险人自致伤害或自杀，但被保险人自致伤害或自杀时为无民事行为能力人的除外；
								<br />
								（三）因被保险人挑衅或故意行为而导致的打斗、被袭击或被谋杀；
								<br />
								（四）猝死或突发急性病（该被保险人已投保突发急性病身故或猝死保险责任的不在此限）、其他疾病(包括但不限于高原反应、中暑、过敏及由过敏引发的变态反应)或其他自身身体原因；
								<br />
								（五）投保前已有的残疾及其并发症；
								<br />
								（六）被保险人接受整容手术、其他内、外科手术或其他诊疗活动过程中发生的医疗意外和医疗损害；
								<br />
								（七）被保险人未遵医嘱，私自服用、涂用、注射药物；
								<br />
								（八）被保险人洗牙、洁齿、验光、装配假眼、假牙、假肢或者助听器等；
								<br />
								（九）投保人、被保险人故意导致发病或发病后故意不及时就医的，但被保险人为无民事行为能力人的除外。
								<br />
								发生上述情形，被保险人身故的，保险人对该被保险人的保险责任终止，向投保人退还该被保险人的未满期净保费，如投保人、被保险人故意制造保险事故的，不退还保险费。
								<br />
								<span class="font_title">
									出现下列任一情形，导致被保险人身故、伤残、支出医疗费用、住院治疗、突发急性病身故或猝死的，保险人不承担给付保险金责任：
								</span>
								<br />
								（一）被保险人妊娠、流产、分娩、不孕症、避孕及绝育手术、先天性畸形、变形或染色体异常；
								<br />
								（二）任何生物、化学、原子能武器，原子能或核能装置所造成的爆炸、灼伤、污染或辐射；
								<br />
								（三）战争、军事行动、暴动或武装叛乱、恐怖袭击；
								<br />
								（四）被保险人从事非法、犯罪活动期间或被依法拘留、服刑期间；
								<br />
								（五）被保险人醉酒或受毒品、管制药物的影响期间；
								<br />
								（六）被保险人酒后驾驶、无有效驾驶证驾驶或驾驶无有效行驶证的机动车期间；
								<br />
								（七）被保险人从事潜水、跳伞、攀岩运动、探险活动、武术比赛、摔跤比赛、特技表演、赛马、赛车等高风险活动期间；
								<br />
								（八）被保险人在家自设病床治疗、健康保健治疗、康复疗养治疗和非医疗行为的治疗等；
								<br />
								（九）住院治疗的，无医院有效的转院证明而自行转院的；
								<br />
								（十）本条款中载明的保险期间外发病的；
								<br />
								（十一）突发急性病身故条款中载明的抢救期后身故的。
								<br />
							</div>
							<span class="font_title">
								根据本保险条款的相关约定，保险人应不承担或免除保险责任的各种情形下的损失、费用或责任，或保险人有权予以扣除、减少的部分，保险人不负责给付保险金。
							</span>
							<br />
							<span class="font_head" style="color: red">
								《中国人寿财产保险股份有限公司意外伤害保险（互联网专属）类附加年龄规范保险条款（注册编号：C00010832322021122437413）》
							</span>
							兹经保险合同双方同意，鉴于投保人已了解保险方案中对被保险人年龄的限制，对于不符合保险方案规定年龄的被保险人，保险人不予承保。
							<br />
							本保单承保被保险人年龄区间须为十六周岁（含）至六十五周岁（含）。
							<br />
							<span class="font_head font_center" style="color: red; text-align: center">
								★投保人、被保险人未履行义务导致的责任免除★
							</span>
							<span class="font_head" style="color: red">
								《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》
							</span>
							<span class="font_title">【未及时交清保险费】</span>
							<br />
							&emsp;除另有约定外，投保人应当在保险合同成立时交清保险费。未交清保险费的，保险合同不生效，保险合同生效前发生保险事故的，保险人不承担保险责任。
							<br />
							<span class="font_title">【未如实告知】</span>
							<br />
							&emsp;订立保险合同时，保险人就被保险人的有关情况提出询问的，投保人应当如实告知。
							<br />
							&emsp;投保人故意或者因重大过失未履行前款规定的义务，足以影响保险人决定是否同意承保或者提高保险费率的，保险人有权解除本保险合同。
							<br />
							&emsp;投保人故意不履行如实告知义务的，保险人对于保险合同解除前发生的保险事故，不承担给付保险金责任，并不退还保险费。
							<br />
							&emsp;投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险人对于保险合同解除前发生的保险事故，不承担给付保险金责任，但应当退还保险费。
							<br />
							<span class="font_title">【出险后未及时报案通知】</span>
							<br />
							&emsp;投保人、保险金申请人知道保险事故发生后，应当及时通知保险人。故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定的部分，不承担给付保险金责任，但保险人通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。
							<br />
							&emsp;上述约定，不包括因不可抗力而导致的迟延。
							<br />
							<span class="font_head" style="color: red; text-align: center">★按比例或部分赔付保险金的情形★</span>
							<span class="font_head" style="color: red">
								《中国人寿财产保险股份有限公司人身意外伤害保险（2022版）（互联网专属）条款（注册编号：C00010832312022042867271）》
							</span>
							一、被保险人身故前保险人已给付本条款约定的伤残保险金的，身故保险金为保险金额扣除已给付伤残保险金后的余额。
							<br />
							二、被保险人自意外伤害发生之日起一百八十日内（含）因该事故身体伤残的，保险人根据本保险合同所附《人身保险伤残评定标准》（保监发[2014]6号，标准编号为JR/T
							0083-2013，以下简称“《伤残评定标准》”）的规定，按该标准所列伤残程度对应的保险金给付比例乘以本保险合同载明的保险金额给付伤残保险金。
							<br />
							三、被保险人如在本次意外伤害事故之前已有伤残，保险人按合并后的伤残程度在《伤残评定标准》中所对应的给付比例给付伤残保险金，但应扣除原有伤残程度在《伤残评定标准》中所对应的伤残保险金。
							<br />
							<span class="font_head" style="color: red; text-align: center">★其他责任免除★</span>
							<span class="font_title">【保险合同无效】</span>
							<br />
							&emsp;订立本保险合同时，投保人对被保险人不具有保险利益的，本保险合同无效，保险人退还净保费。
							<span class="font_head" style="color: red; text-align: center">★未尽事宜以条款和保险合同约定为准★</span>
							<br />
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile} from '@/util/util'
import {getProductPrice} from '@/api/insurance/product'
import {optionBenefit, optionPlanTy, optionPremium, optionShortPeriodRate} from '@/const/crud/insurance/productDetail'
// import {getProductDetails} from '@/api/insurance/product'

export default {
	name: 'Product20Details',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlanTy,
			optionPremium: optionPremium,
			optionBenefit: optionBenefit,
			optionShortPeriodRate: optionShortPeriodRate,
			categories: [],
			// nprice: [240, 470, 700, 970, 1200, 1450, 1680, 1860, 2100, 2330, 330, 660, 990, 1380, 1650, 2070, 2400, 2700, 2970, 3300],
			// proportion: [0.15, 1, 0.3, 1, 1, 0.6, 1, 1, 1, 1, 1, 1], //团意险利率
			// dcproportion: [1, 1.10, 1.15, 1.2, 1.25], //团意险档次利率
			dangci: 0,
			qixian: 12,
			qixians: [
				{
					value: 12,
					label: '1年',
				},
				{
					value: 6,
					label: '6个月',
				},
				{
					value: 3,
					label: '3个月',
				},
				{
					value: 1,
					label: '1个月',
				},
			],
			dataPlan: [
				{
					insuredItem: '身故/伤残',
					plan1: '10万',
					plan2: '20万',
					plan3: '30万',
					plan4: '40万',
					plan5: '50万',
					plan6: '60万',
					plan7: '70万',
					plan8: '80万',
					plan9: '90万',
					plan10: '100万',
				},
				{
					insuredItem: '医疗费用|限社保用药',
					plan1: '1万',
					plan2: '2万',
					plan3: '3万',
					plan4: '6万',
					plan5: '7万',
					plan6: '9万',
					plan7: '10万',
					plan8: '16万',
					plan9: '18万',
					plan10: '20万',
				},
				{
					insuredItem: '住院津贴',
					plan1: '100元/天',
					plan2: '100元/天',
					plan3: '100元/天',
					plan4: '150元/天',
					plan5: '150元/天',
					plan6: '150元/天',
					plan7: '150元/天',
					plan8: '200元/天',
					plan9: '200元/天',
					plan10: '200元/天',
				},
				{
					insuredItem: '',
					plan1: '每次90天，累计180天，0免赔',
				},
				{
					insuredItem: '4类职业',
					plan1: '--元/年',
					plan2: '--元/年',
					plan3: '--元/年',
					plan4: '--元/年',
					plan5: '--元/年',
					plan6: '--元/年',
					plan7: '--元/年',
					plan8: '--元/年',
					plan9: '--元/年',
					plan10: '--元/年',
				},
				{
					insuredItem: '5-6类职业',
					plan1: '--元/年',
					plan2: '--元/年',
					plan3: '--元/年',
					plan4: '--元/年',
					plan5: '--元/年',
					plan6: '--元/年',
					plan7: '--元/年',
					plan8: '--元/年',
					plan9: '--元/年',
					plan10: '--元/年',
				},
				// , {
				//     insuredItem: '钢骨结构工、钢架架设工、 焊工（高空）、安装工（高空）',
				//     plan1: '--元/年',
				//     plan2: '--元/年',
				//     plan3: '--元/年',
				//     plan4: '--元/年',
				//     plan5: '--元/年',
				//     plan6: '--元/年',
				//     plan7: '--元/年',
				//     plan8: '--元/年',
				//     plan9: '--元/年',
				//     plan10: '--元/年'
				// }
			],
			dataQA: [
				{
					question: '本产品的保险公司是哪家？',
					answer:
						'本产品由中国人寿财产保险股份有限公司承保。本公司除港澳台外全国其他省、自治区、直辖市均设有分公司，本产品面向全国销售（不含港澳台地区）。',
				},
				{
					question: '团体意外险的保障范围包括哪些？',
					answer:
						'保险责任成立基于2个前提，第一是被保险人遭受保单约定的意外伤害，第二是事故发生在保险期间内。保障范围包括：<br/>1、如果被保险人死亡或残疾承担给付保险金责任，对被保险人未遭受外来伤害，而是由于自身身体原因（包括但不限于：猝死、心脏骤停、呼吸衰竭、急性病突发等排除外来伤害的原因）导致的死亡或残疾不负责赔偿。<br/>2、被保险人在二级或二级以上公立医院，或保险人认可的其他医疗机构接受治疗，保险人按社保标准赔付医疗费用（即自费部分不赔）。<br/>3、如果被保险人根据伤情需要住院，保险人按保单约定支付住院津贴。',
				},
				{
					question: '意外的定义是什么？',
					answer: '意外伤害：指以外来的、突发的、非本意的和非疾病的客观事件为直接且单独的原因致使身体受到的伤害。',
				},
				{
					question: '哪些职业不保？',
					answer:
						'本产品拒绝承保职业（即保险人不承担任何赔偿责任）：农牧渔业、海上作业、地质矿产业、化工/军工制造业、影视及演艺业、建筑物外墙维护及玻璃幕墙安装维护人员、桥梁/隧道工程人员、凿岩工、防水工、水运工程施工、水坝工程人员、潜水工作人员、体育运动、各种杂技人员、驯兽师、涉及火药/炸药/爆破的相关工作、易燃易爆/危险化学品运输司机及随车工、特种兵/军人/武警/公安/警察/消防等治安人员、高压电工作人员、快递/外卖配送等。',
				},
				{
					question: '如果投保，无对应职业可选择，应如何处理？',
					answer: '请咨询平台工作人员，由专业客服为您解答。否则，保险人可能拒保。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer:
						'直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→线上支付保费→获取保单。本产品支持使用网上银行、微信、支付宝进行保费支付。',
				},
				{
					question: '保单和发票怎么获取？',
					answer:
						'线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，该产品保司目前不支持开具“增值税专用发票”，请知悉。',
				},
				{
					question: '保单如何查验真伪？',
					answer: '可以通过拨打国寿财险全国客服电话95519进行人工查询。',
				},
				{
					question: '团意险是什么时候起保生效？',
					answer:
						'方案生效的最快时间是T+2。如客户在2021年12月27日的任意时间内投保，保单最快生效时间是2021年12月29日0时。',
				},
				{
					question: '团意险的替换是什么时候生效？批增是什么时候生效？',
					answer:
						'替换是生效时间是T+1。批增是生效时间是T+2。如客户在2021年12月27日的任意时间内替换，则批单生效时间是2021年12月28日0时，客户在2021年12月27日的任意时间内批增，则批单生效时间是2021年12月29日0时。',
				},
				{
					question: '被保险人怎么批增呢？',
					answer:
						'在美保官网登录。登录后点击我的保单→点击被保险人→点击增加保障人员→选择起保时间→录入姓名、身份证号、工种→选择发票信息→提交，缴费即可。如有疑问，请咨询平台工作人员，由专业客服为您解答。',
				},
				{
					question: '被保险人可以替换吗？',
					answer:
						'本产品不支持批减被保险人、变更保额。保险期限为3个月以内（含）的保单不支持替换被保险人，6个月和1年的保单支持替换被保险人（已出险人员除外）。替换时，原4类职业人员只能替换为新的4类职业人员，原5-6类职业人员只能替换为新的5-6类职业人员。',
				},
				{
					question: '出险人员是否可替换出去？',
					answer: '不可以。',
				},
				{
					question: '怎么理赔？',
					answer: '出险后请拨打理赔专线报案→收集资料→提交审核→支付结案。',
				},
				{
					question: '什么是高空作业？',
					answer:
						'国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。',
				},
				{
					question: '如果从事高处作业，但是没有高处作业证，保险公司是否拒赔？',
					answer:
						'不会拒赔。若从事高处作业不系安全带或者无特种作业操作证（高处作业），则保险人对按保单规定的应承担的保险责任，免赔50%。',
				},
			],
			isDownLoading: false,
			newPrice: [],
			newPriceFee: {},
		}
	},
	created() {
		this.init()
	},
	mounted() {},
	methods: {
		init() {
			let query = {
				pid: this.productId,
			}
			getProductPrice(query).then(({data: {data = [], code = -1}}) => {
				if (code !== 0 || data.length === 0) {
					this.$message.error('获取数据有误!')
					return
				}
				this.newPriceFee = data[0].shortRateMaps || []
				data.forEach((item) => {
					let {price} = item
					// let config = JSON.parse(item.config.replace('\n', ''))
					//把钱存起来
					this.newPrice.push(price / 100)
				})
				//算钱
				this.computePrice()
			})
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex === 3) {
				if (columnIndex === 1) {
					return [1, 11]
				}
			}
		},
		handleInsure(type) {
			this.$emit('insure', type)
		},
		computePrice() {
			if (this.newPriceFee.length <= 0) {
				this.$message.error('费率有误！')
				return
			}
			var danwei = ''
			if (this.qixian == 12 || this.qixian == 0) {
				danwei = '元/年'
			} else {
				danwei = '元/' + this.qixian + '个月'
			}
			let tempStart = 0
			if (this.dangci == 2) {
				tempStart = 20
			}
			for (let i = 0; i < 10; i++) {
				this.dataPlan[4]['plan' + (i + 1)] =
					((this.newPrice[tempStart + i] * this.newPriceFee[this.qixian]) / 100).toFixed(0) + danwei
				//5-6类上浮价格15%
				this.dataPlan[5]['plan' + (i + 1)] =
					((this.newPrice[tempStart + 10 + i] * this.newPriceFee[this.qixian]) / 100).toFixed(0) + danwei
				// // 特殊工种
				// this.dataPlan[6]['plan' + (i + 1)] = (Math.ceil((this.nprice[20 + i] * this.dcproportion[this.dangci]).toFixed(2)) *
				//     this.proportion[this.qixian - 1]).toFixed(2) + danwei
			}
			// for (var i = 0; i < 10; i++) {
			//   this.dataPlan[4]['plan' + (i + 1)] = (Math.ceil((this.nprice[i] * this.dcproportion[this.dangci]).toFixed(2)) *
			//     this.proportion[this.qixian - 1]).toFixed(2) + danwei
			//   //5-6类上浮价格15%
			//   this.dataPlan[5]['plan' + (i + 1)] = (Math.ceil((this.nprice[10 + i] * this.dcproportion[this.dangci]).toFixed(2)) *
			//     this.proportion[this.qixian - 1]).toFixed(2) + danwei
			//   // // 特殊工种
			//   // this.dataPlan[6]['plan' + (i + 1)] = (Math.ceil((this.nprice[20 + i] * this.dcproportion[this.dangci]).toFixed(2)) *
			//   //     this.proportion[this.qixian - 1]).toFixed(2) + danwei
			// }
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `gsc_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
/${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.red-bold {
	color: red;
	font-weight: bold;
}

.font_title {
	font-weight: bold;
	font-size: 1.05em;
}

.font_head {
	font-weight: bold;
	font-size: 1.4em;
	margin: 20px 0;
	display: block;
}

.font_center {
	text-align: center;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}

@media aural {
}
</style>
